module.exports = __webpack_public_path__ + "static/media/sel_19_276.73680be6.mp4";